import ApplicationMemberFile from '../dto/ApplicationMemberFile';
import Error from '../model/Error';
import axios from 'axios';

export default class ApplicationMemberFileRepository {
    static remove(file, applicationMember) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/club/application-member/${applicationMember.id}/files/${file.hash}`)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static upload(file, title, applicationMember) {
        return new Promise((resolve, reject) => {
            const url = `/club/application-member/${applicationMember.id}/files`;

            axios.post(
                url,
                file,
                {
                    headers: {
                        'X-File-title': title,
                    }
                })
                .then((response) => {
                    resolve(ApplicationMemberFile.fromData(response.data.data))
                })
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static downloadAll(applicationMemberId) {
        document.location = `/api/club/application-member/${applicationMemberId}/files/download/all`;
    }

    static checkDownloadAll(applicationMemberId) {
        const url = `/club/application-member/${applicationMemberId}/files/download/all/check`;
        return axios.get(url);
    }
}
